import { getToken } from '../Context/User.context';
import API from './index';

export const getAirports = () => API.get('/airport', {headers: { "Authorization": `Bearer ${getToken()}`}});
